// src/services/store.service.js
import axiosInstance from "../utils/axiosInstance";
import { errorHandler } from "../utils/errorHandler";
import { storesUrl, getStoreAndMetaByUserIdUrl } from "../utils/urls";

class StoreService {
  findOne = async (id) => {
    return axiosInstance
      .get(`${storesUrl}/${id}`)
      .then((res) => res.data)
      .catch(errorHandler);
  }; // [3]

  update = async (id, formData) => {
    return axiosInstance
      .patch(`${storesUrl}/${id}`, formData)
      .then((res) => res.data)
      .catch(errorHandler);
  }; // [3]

// src/services/store.service.js
findByUserId = async (userId) => {
  return axiosInstance
    .get(getStoreAndMetaByUserIdUrl(userId), {
      // Resolve 404 so it won't trigger .catch(errorHandler)
      validateStatus: (s) => (s >= 200 && s < 300) || s === 404,
    })
    .then((res) => (res.status === 404 ? null : res.data))
    .catch(errorHandler);
};


  getStoreIdByUserId = async (userId) => {
    const data = await this.findByUserId(userId);
    return data?.store?.id ?? null;
  }; // [3]
}

export default StoreService; // [3]
